import * as React from "react";
import { CalendarIcon } from "@radix-ui/react-icons";
import { format } from "date-fns";
import { DateRange } from "react-day-picker";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/Button";
import { Calendar } from "@/components/ui/Calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/Popover";

interface DatePickerWithRangeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  value: { date_From: Date | undefined; date_to: Date | undefined };
  onValueChange: (value: {
    date_from: Date | undefined;
    date_to: Date | undefined;
  }) => void;
  label?: string;
}

export function DatePickerWithRange({
  name,
  value,
  onValueChange,
  label = "",
  className,
}: DatePickerWithRangeProps) {
  const [open, setOpen] = React.useState(false);

  const handleDateChange = (range: DateRange | undefined) => {
    if(!range?.from){
      return;
    }
    
    onValueChange({
      date_from: range?.from,
      date_to: range?.to,
    });

    if (range?.from && range?.to) {
      setOpen(false);
    }
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            id={name}
            variant={"outline"}
            className={cn(
              "w-full flex items-center font-normal h-8",
              !value.date_From ? "justify-center" : "justify-start",
              !value.date_From && "text-muted-foreground"
            )}
          >
            <CalendarIcon
              className={cn(
                "h-4  text-gray-400 ",
                !value.date_From ? "m-0" : "mr-2"
              )}
            />
            {value.date_From ? (
              value.date_to ? (
                <>
                  {format(value.date_From, "LLL dd, y")} -{" "}
                  {format(value.date_to, "LLL dd, y")}
                </>
              ) : (
                format(value.date_From, "LLL dd, y")
              )
            ) : (
              <></>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto p-0"
          align="start"
          style={{ zIndex: 10 }}
        >
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={value.date_From}
            selected={{ from: value.date_From, to: value.date_to }}
            onSelect={handleDateChange}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
